import React from 'react';

export default function NotFound() {
  return (
    <h3>Not found</h3>
  );
}